import React, { useState, useContext } from "react";
import { UserContext } from "../index";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { useNavigate } from "react-router-dom";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { titleCase } from "../../helpers/formatter";
import { Info, ShieldCheck } from "lucide-react";

export default function Vote() {
  const data = useContext(UserContext);
  const { user } = data;
  const navigate = useNavigate();
  const [vote, setVote] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("");

  function clickEffect() {
    const userInfo = {
      id: user.id,
      name: user.name,
      currentVote: user.votes.stage1,
      vote,
    };

    if (paymentMethod === "ps") {
      navigate("/secured-payment", {
        state: { ...userInfo },
      });
    } else {
      navigate("/bank-info", {
        state: { ...userInfo },
      });
    }
  }

  return (
    <Box>
      <Typography>
        Help <strong>{titleCase(user.name)}</strong> get as much votes as
        possible to help {user.gender === "Male" ? "him" : "her"} win the
        Kiddies Crown Contest.
      </Typography>
      <br />
      <Box sx={{ display: "flex", gap: 2, justifyContent: "center" }}>
        <FormControl fullWidth>
          <InputLabel id="demo-simple-select-label">Select Votes</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={vote}
            label="Select Votes"
            onChange={(e) => {
              setVote(e.target.value);
            }}
          >
            <MenuItem value="">
              <em>None</em>
            </MenuItem>
            <MenuItem value={5}>5 votes</MenuItem>
            <MenuItem value={10}>10 votes</MenuItem>
            <MenuItem value={20}>20 votes</MenuItem>
            <MenuItem value={50}>50 votes</MenuItem>
            <MenuItem value={100}>100 votes</MenuItem>
            <MenuItem value={200}>200 votes</MenuItem>
            <MenuItem value={300}>300 votes</MenuItem>
            <MenuItem value={500}>500 votes</MenuItem>
            {/* <MenuItem value={1000}>1000 votes</MenuItem> */}
          </Select>
        </FormControl>
        {vote && (
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Vote Method</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={paymentMethod}
              label="Vote Method"
              onChange={(e) => {
                setPaymentMethod(e.target.value);
              }}
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {/*<MenuItem value="fw">Flutterwave (secured payment)</MenuItem>*/}
              <MenuItem value="ps">
                Paystack - Secured <ShieldCheck width={20} />
              </MenuItem>
              <MenuItem value="bt">Bank Transfer / Deposit</MenuItem>
            </Select>
          </FormControl>
        )}
      </Box>
      {vote && paymentMethod && (
        <Box sx={{ marginTop: 3 }}>
          <Box sx={{ display: "flex", gap: 0.5, alignItems: "center", mb: 2 }}>
            <Info />
            <Typography fontWeight="bold">
              Why you pay to vote?{" "}
              <a
                style={{ color: "purple", textDecoration: "none" }}
                href="/feed-a-child"
                target="_blank"
                rel="noopener noreferrer"
              >
                Click here
              </a>
            </Typography>
          </Box>
          <Button
            variant="contained"
            size="large"
            fullWidth
            sx={{ fontWeight: "bold" }}
            onClick={clickEffect}
          >
            Proceed
          </Button>
        </Box>
      )}
    </Box>
  );
}
